var map = {
	"./admin/admin.png": 979,
	"./boat/boat.png": 980,
	"./bpcl/bpcl.png": 981,
	"./eseal-ecs-lb-486270027/eseal-ecs-lb-486270027.png": 982,
	"./finolex/finolex.png": 983,
	"./icapidilite/icapidilite.png": 984,
	"./mango/mango.png": 985,
	"./orient/orient.png": 986,
	"./pidilite/pidilite.png": 987,
	"./sudhakar/sudhakar.png": 988,
	"./valvoline/valvoline.png": 989,
	"./vguard/vguard.png": 990
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 978;